// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format13 } from '../../constants';

import { format2 } from '../../constants';

/** Congo - Kinshasa */
const CD: PhoneNumberData = [243, 'CD', 7, format13, 9, format2];

export default CD;
